export function fmtCurrency(v: number, currency: string): string;
export function fmtCurrency(v: number | null | undefined, currency: string): string | null;
export function fmtCurrency(v: number | null | undefined, currency: string) {
  if (v === null || v === undefined) {
    return null;
  }
  if (currency === 'JPY') {
    return '¥' + v.toLocaleString('ja-JP');
  }
  if (currency === 'USD') {
    return '$' + v.toLocaleString('en-US');
  }
  return `${v}`;
}
